<div style="margin: 10px">
    <rask-color-picker [colors]="colors" [color]="color"
        (colorChange)="colorChanged($event)">
    </rask-color-picker>
</div>
